module.exports = __webpack_public_path__ + "static/media/bq.33213090.svg";